import React from 'react'
import cls from 'classnames'

import permManager from 'utils/permManager'

import DataContainer from 'components/elements/DataContainer'
import SettingsHeader from 'components/elements/SettingsHeader'

import IncidentResponseSettings from './IncidentResponseSettings'

require('components/styles/layouts/settings/accountSettings.styl')

class IncidentResponseSettingsPage extends React.Component {
  state = {
    error: null,
  }

  componentWillMount() {
    const { isGroupSettings } = this.props
    if (!isGroupSettings) this.props.getIncidentResponse()
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.error) {
      this.setState({
        error: { ...nextProps.error, refreshAction: this.props.fetchData },
      })
    } else if (this.state.error) {
      this.setState({ error: null })
    }
  }

  componentWillUnmount() {
    const { isGroupSettings } = this.props
    if (!isGroupSettings) this.props.getIncidentResponseCancel()
  }

  render() {
    const { error } = this.state
    const {
      data,
      loader,
      history,
      companyFilter,
      licenses,
      userId,
      integrations,
      permissions,
      updateSettingsField,
      updateDeepSettingsField,
      submitIncidentResponse,
      isGroupSettings,
      groupSettingsNameByPartner,
      isStaticSalesDemo,
      ff,
      isMasterUser,
    } = this.props

    return (
      <div className={cls('card pz', { scrollable: !loader })} id="Settings_ScrollToTop_card">
        <SettingsHeader header="Threat Protection" subHeader="Incident Response" />
        <DataContainer
          error={error}
          loader={loader}
          className={cls({ 'with-loader': loader })}
          partnerAccess={{
            companyFilter,
            checkPartnerAccess: permManager.pages.settings.threats_protection.incident_response,
          }}
        >
          <IncidentResponseSettings
            data={data}
            ff={ff}
            licenses={licenses}
            integrations={integrations}
            permissions={permissions}
            userId={userId}
            history={history}
            updateSettingsField={updateSettingsField}
            updateDeepSettingsField={updateDeepSettingsField}
            submitIncidentResponse={submitIncidentResponse}
            isGroupSettings={isGroupSettings}
            groupSettingsNameByPartner={groupSettingsNameByPartner}
            isStaticSalesDemo={isStaticSalesDemo}
            isMasterUser={isMasterUser}
          />
        </DataContainer>
      </div>
    )
  }
}

export default IncidentResponseSettingsPage
